<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/juridical')" style="cursor: pointer">Jurídico</li>
        <li class="breadcrumb-item active" aria-current="page">Contratos de Proyectos</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div slot="header">
              <h3>Buscar</h3>
            </div>
            <vs-row vs-justify="center">
              <vs-col vs-justify="center" vs-align="center" vs-w="4">
                <vs-input color="warning" style="width: 98%;" label="PID, CID, SID o Nombre Comercial/Razón Social del Proveedor..." v-model="search" v-on:keyup.enter="filterProjectsContracts()"/>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="2">
                <vs-select color="warning" style="width: 95%;margin-left: 1%" multiple autocomplete label="Estatus de Proyecto" v-model="searchProjectStatus">
                  <vs-select-item :key="item.type" :value="item.type" :text="item.text" v-for="item in projectStatusOptions" />
                </vs-select>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="2">
                <vs-select color="warning" style="width: 95%;" multiple autocomplete label="Estatus de Contrato" v-model="searchContractStatus">
                  <vs-select-item :key="item.type" :value="item.type" :text="item.text" v-for="item in contracStatusOptions" />
                </vs-select>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-select color="warning" style="width: 98%;" multiple autocomplete label="Domiciliados" v-model="searchDirectBilling">
                  <vs-select-item :key="1" :value="1" :text="'SI'"/>
                  <vs-select-item :key="0" :value="0" :text="'NO'"/>
                </vs-select>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-checkbox size="large" color="warning" style="margin-top: 12%" v-model="searchProjectsNotSigned">Proyectos sin PDF firmados</vs-checkbox>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-checkbox size="large" color="warning" style="margin-top: 12%" v-model="searchProjectsNotGenerated">Proyectos sin PDF generados</vs-checkbox>
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-button style="margin-left: 35%; margin-top: 15%;" color="warning" type="filled" icon="search" v-on:click="filterProjectsContracts()" :disabled="loading"></vs-button>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" style="margin-top:1%;">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div slot="header">
              <h3 v-if="loading">Proyectos: <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/></h3>
              <h3 v-else>Proyectos: {{projects_contracts.length}}</h3>
            </div>
            <template lang="html">
              <div>
                <vs-table stripe :data="projects_contracts" noDataText="No se encontraron registros">
                  <template slot="thead">
                    <vs-th>PID</vs-th>
                    <vs-th>Alias</vs-th>
                    <vs-th>Estatus de Proyecto</vs-th>
                    <vs-th>Proveedor</vs-th>
                    <vs-th>Solicitante</vs-th>
                    <vs-th>Domiciliado</vs-th>
                    <vs-th>Acciones</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(renglon, index) in data" >
                      <vs-td>{{renglon.id}}</vs-td>
                      <vs-td>{{renglon.alias}}</vs-td>
                      <vs-td>{{renglon.status_named}}</vs-td>
                      <vs-td v-if="renglon.supplier_id !== null">{{'SID: '+renglon.supplier_id+' '+renglon.supplier.tradename}}</vs-td>
                      <vs-td v-else>Sin Proveedor</vs-td>
                      <vs-td v-if="renglon.client.user.person_type === 1">{{'CID: '+renglon.client_id+' '+renglon.client.fiscal.first_name + " " +renglon.client.fiscal.last_name_1}}</vs-td>
                      <vs-td v-else>{{'CID: '+renglon.client_id+' '+renglon.client.fiscal.name}}</vs-td>
                      <vs-td v-if="renglon.finance !== null">
                        <span v-if="renglon.finance.direct_billing === 1">SI</span>
                        <span v-else>NO</span>
                      </vs-td>
                      <vs-td v-else>N/A</vs-td>
                      <vs-td>
                        <vs-tooltip text="Domiciliar/No Domiciliar" v-if="renglon.finance !== null">
                          <vs-switch color="success" v-model="renglon.finance.direct_billing" @click="domiciliar(renglon.id)">
                            <span slot="on">Domiciliado</span>
                            <span slot="off">No Domiciliado</span>
                          </vs-switch>
                        </vs-tooltip>
                        <vs-tooltip text="Archivo">
                          <vs-button radius color="primary" type="filled" icon="insert_drive_file" @click="verDownloadDialog(renglon)"></vs-button>
                        </vs-tooltip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </template>
          </vs-card>
        </vs-col>
      </vs-row>

      <!-- DIÁLOGO PARA DESCARGA DE LOS ARCHIVOS-->
      <vs-popup :title="titleFile" :active.sync="showDownloadDialog" class="con-vs-popup extended-popup">
        <vs-row v-if="project_reference != null" vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <div class="container-fluid">

              <!-- versiones con componente -->
              <div v-if="project_reference.contracts.length > 0">
                <vs-row>
                  <vs-checkbox color="warning" v-model="uploadAll">Al subir uno, actualizar todos</vs-checkbox>
                </vs-row>
                <br>
                <div v-for="contract in project_reference.contracts">
                  <vs-row>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
                      <h3>{{contract.type.name}}</h3>
                    </vs-col>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="1">
                    <span v-if="contract.status !== null && contract.status !== ''" class="label" v-bind:class="{'label-status-1': (contract.status == 'signed'),
                                            'label-status-10': (contract.status == 'generated' || contract.status == 'sent'),
                                            'label-status-9': (contract.status == 'canceled')}">
                                        {{contract.status}}</span>
                      <span v-else class="label label-status-10">not generated</span>
                    </vs-col>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
                      <span v-if="contract.signing_type == 1">Autógrafa Manual</span>
                      <span v-else-if="contract.signing_type == 2">MIFIEL</span>
                      <span v-else-if="contract.signing_type == 3">Autógrafa Digital (FAD)</span>
                      <span v-else/>
                    </vs-col>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="3">
                      <span v-for="signatory in contract.signatories_json">{{signatory.email}}, </span>
                    </vs-col>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
                      Creación: {{contract.created_at | humanDate}}
                    </vs-col>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
                      <vs-tooltip text="Eliminar" v-if="contract.status !== 'signed'">
                        <vs-button radius color="danger" type="filled" icon="cancel" @click="eliminar(contract)"></vs-button>
                      </vs-tooltip>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <document-upload-lite
                            :accepts="['pdf']"
                            upload-type="not_signed"
                            name="PDF Contrato sin firmar"
                            :check-url="checkUrl(contract.project_id, contract.id)"
                            :view-url="viewUrl(contract.project_id, contract.id)"
                            :download-url="downloadUrl(contract.project_id, contract.id)"
                            :upload-url="uploadUrl(contract.project_id, contract.id)"
                            width="1/2"
                            :upload-all="uploadAll"
                    />

                    <document-upload-lite
                            :accepts="['pdf','png','jpg','jpeg']"
                            upload-type="signed"
                            name="PDF Contrato firmado"
                            :check-url="checkUrl(contract.project_id, contract.id)"
                            :view-url="viewUrl(contract.project_id, contract.id)"
                            :download-url="downloadUrl(contract.project_id, contract.id)"
                            :upload-url="uploadUrl(contract.project_id, contract.id)"
                            width="1/2"
                            :uploadAll="uploadAll"
                    />
                  </vs-row>
                </div>
              </div>
              <div v-else>
                <vs-row>
                  <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="3">
                    <h3>Subir contrato único</h3>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <document-upload-lite
                          :accepts="['pdf']"
                          upload-type="not_signed"
                          name="PDF Contrato sin firmar"
                          :check-url="checkUrl(project_reference.id, null)"
                          :view-url="viewUrl(project_reference.id, null)"
                          :download-url="downloadUrl(project_reference.id, null)"
                          :upload-url="uploadUrl(project_reference.id, null)"
                          width="1/2"
                          :upload-all="uploadAll"
                  />

                  <document-upload-lite
                          :accepts="['pdf','png','jpg','jpeg']"
                          upload-type="signed"
                          name="PDF Contrato firmado"
                          :check-url="checkUrl(project_reference.id, null)"
                          :view-url="viewUrl(project_reference.id, null)"
                          :download-url="downloadUrl(project_reference.id, null)"
                          :upload-url="uploadUrl(project_reference.id, null)"
                          width="1/2"
                          :uploadAll="uploadAll"
                  />
                </vs-row>
              </div>

              <!-- fin versiones con componente -->
            </div>
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
  </div>

</template>

<script lang="js">

  import {humanDateFilter} from "../../../components/admin/filters/humanDateFilter";
  import DocumentUploadLite from "@components/misc/DocumentUploadLite";

  const projectStatusOptions = [
    { type: 0, text: "Sin Estatus"}
    ,{ type: 1, text: "Lead"}
    ,{ type: 2, text: "En revisión"}
    ,{ type: 3, text: "Pre-aprobado"}
    ,{ type: 4, text: "Aprobado"}
    ,{ type: 5, text: "En fondeo"}
    ,{ type: 6, text: "Firma de contratos"}
    ,{ type: 7, text: "En instalación"}
    ,{ type: 8, text: "Entregado"}
    ,{ type: 9, text: "Rechazado"}
    ,{ type: 10, text: "Reembolsado"}
  ];

  const contracStatusOptions = [
    { type: 'generated', text: "Generado"}
    ,{ type: 'sent', text: "Enviado"}
    ,{ type: 'signed', text: "Firmado"}
  ];

  export default  {
    filters: {
      'humanDate': humanDateFilter
    },
    components: {DocumentUploadLite},
    name: 'projects-contracts',
    props: [],
    mounted () {
      // this.loading = true;
      // this.$vs.notify({title:'Cargando...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
      // axios.post( '/api/juridical/project_contracts').then((resolve) => {
      //   this.$vs.notify({title:'¡Listo!',text:'Datos cargados correctamente',color:'success',position:'bottom-center',icon:'done'})
      //   this.projects_contracts = resolve.data.data;
      //   this.loading = false;
      // }).catch(error => {
      //   this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
      //   this.loading = false;
      // });
    },
    data () {
      return {
        search: '',
        searchProjectStatus: [],
        projectStatusOptions: projectStatusOptions,
        searchContractStatus: [],
        contracStatusOptions: contracStatusOptions,
        searchDirectBilling: [],
        searchProjectsNotSigned: false,
        searchProjectsNotGenerated: false,

        projects_contracts: [],
        loading: false,
        cancelMessageConfirmation: '',
        showDownloadDialog: false,
        project_reference: null,
        titleFile: '',
        uploadAll: false,
      }
    },
    methods: {
      filterProjectsContracts() {
        if(!this.loading){
          this.loading = true;
          this.$vs.notify({title:'Actualizando...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
          axios.post( '/api/juridical/project_contracts',{
            'search': this.search,
            'status': this.searchProjectStatus,
            'contract_status': this.searchContractStatus,
            'direct_billing': this.searchDirectBilling,
            'not_signed': this.searchProjectsNotSigned,
            'not_generated': this.searchProjectsNotGenerated
          }).then((resolve) => {
            this.$vs.notify({title:'¡Listo!',text:'Datos cargados correctamente',color:'success',position:'bottom-center',icon:'done'})
            this.projects_contracts = resolve.data.data;
            this.loading = false;
          }).catch(error => {
            this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
            this.loading = false;
          });
        }
      },
      domiciliar(project_id){
        this.$vs.notify({title:'Cambiando PID '+project_id+'...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
        axios.post( '/api/juridical/project_contracts/direct_billing/change',{
          'project_id': project_id,
        }).then((resolve) => {
          this.$vs.notify({title:'¡Listo!',text:'PID: '+project_id+' cambiado correctamente',color:'success',position:'bottom-center',icon:'done'})
          this.filterProjectsContracts()
        }).catch(error => {
          this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
        });
      },
      eliminar(contract){
        this.cancelMessageConfirmation = '¿Desea eliminar el contrato '+contract.type.name+' del PID: '+contract.project_id+'?';
        if(confirm(this.cancelMessageConfirmation)){
          this.cerrarDialog();
          this.$vs.notify({title:'Eliminando '+contract.type.name+' del PID: '+contract.project_id+'...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
          axios.post( '/api/juridical/project_contracts/contract/delete',{
            'contract_id': contract.id,
          }).then((resolve) => {
            this.$vs.notify({title:'¡Listo!',text:contract.type.name+' del PID: '+contract.project_id+' eliminado correctamente',color:'success',position:'bottom-center',icon:'done'})
            this.filterProjectsContracts()
          }).catch(error => {
            this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
          });
        }
      },
      verDownloadDialog(renglon){
        this.showDownloadDialog = true;
        this.project_reference = renglon;
        this.titleFile = 'Descargar contratos del PID '+renglon.id;
      },
      cerrarDialog(){
        this.showDownloadDialog = false;
        this.project_reference = null;
        this.titleFile = '';
      },
      checkUrl(project_id, contract_id){
          return `project/${project_id}/contracts/info/contract/${contract_id}`;
        return null;
      },
      viewUrl(project_id, contract_id){
          return `project/${project_id}/contracts/view/contract/${contract_id}`;
        return null;
      },
      downloadUrl(project_id, contract_id){

          return `project/${project_id}/contracts/download/contract/${contract_id}`;
        return null;
      },
      uploadUrl(project_id, contract_id){

          return `project/${project_id}/contracts/upload/contract/${contract_id}`;
        return null;
      }
    },
}


</script>

<style scoped lang="scss">
  .src-views-admin-juridical-projects-contracts {

  }
</style>
